<div class="s" [ngClass]="cls()">
  <span *ngIf="state() !== 'Active'">{{ state() }}</span>
  <span *ngIf="state() === 'Active'">
    {{ tournament.eventSchedules.length > 1 ? 'From' : '' }}
    <fz-currency [value]="entryAmount() || 0"></fz-currency>
  </span>
</div>
